<template>
  <vx-card>
    <label class="vs-input--label">Житель</label>
    <v-select
      v-if="users !== null"
      label="name"
      :options="users"
      :clearable="false"
      class="mb-4"
      @input="selectUser"
    >
      <div slot="no-options">Совпадений не найдено</div>
    </v-select>

    <vs-input class="w-full mb-4" label="ФИО" v-model="newRequest.full_name" />

    <vs-input class="w-full mb-4" label="Телефон" v-model="newRequest.phone" />

    <vs-input class="w-full mb-4" label="Адрес" v-model="newRequest.address" />

    <label class="vs-input--label">Дата и время</label>
    <flat-pickr
      class="block w-full mb-4"
      :config="configdateTimePicker"
      v-model="newRequest.date_recommend"
    />

    <label class="vs-input--label">Категории</label>
    <ul class="mb-4">
      <li class="mb-1" v-for="(category, index) in categories" :key="index">
        <vs-checkbox v-model="newRequest.services" :vs-value="category.id">{{
          category.name
        }}</vs-checkbox>
      </li>
    </ul>

    <vs-button
      @click="createRequest"
      :disabled="!validateForm"
      class="mr-5"
      ref="loadableButton"
      type="relief"
      vslor="primary"
    >
      Создать
    </vs-button>
  </vx-card>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

import { DateTime } from "luxon";

export default {
  data: () => ({
    newRequest: {
      full_name: "",
      phone: "",
      address: "",
      services: [],
      date_recommend: "",
      user: 0,
    },
    users: null,
    categories: null,

    configdateTimePicker: {
      enableTime: true,
      dateFormat: "d.m.Y H:i",
      noCalendar: false,
      time_24hr: true,
      locale: RussianLocale,
      minDate: "today",
      minuteIncrement: 10,
    },
  }),
  components: {
    flatPickr,
  },
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.newRequest.full_name !== "" &&
        this.newRequest.phone !== "" &&
        this.newRequest.address !== "" &&
        this.newRequest.services.length > 0 &&
        this.newRequest.date_recommend !== "" &&
        this.newRequest.user !== 0
      );
    },
  },
  methods: {
    selectUser(val) {
      this.newRequest.full_name = val.full_name;
      this.newRequest.phone = val.phone;
      this.newRequest.address = val.address;
      this.newRequest.user = val.id;
    },
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getAllusers() {
      this.$vs.loading();
      this.users = [];

      this.$load(async () => {
        let res = (await this.$api.users.getUsers()).data;

        res.forEach((user) => {
          if (!user.in_consideration && user.is_confirmed) {
            let countyName =
              user.homes[0].county_type == "forest" ? "ГЛ" : "ГП";

            let userData = {
              id: user.id,
              name: `${user.full_name} | ${countyName}, ${user.homes[0].homestead_number}`,
              full_name: user.full_name,
              address: user.homes[0].address,
              phone: user.phone,
            };
            this.users.push(userData);
          }
        });

        this.$vs.loading.close();
      });
    },
    getAllCategory() {
      this.$vs.loading();
      this.categories = [];

      let payload = {
        limit: -1,
      };

      this.$load(async () => {
        let res = (
          await this.$api.services.getCategories(payload ? payload : "")
        ).data;

        res.results.forEach((category) => {
          let categoryData = {
            id: category.id,
            name: category.name,
          };

          this.categories.push(categoryData);
        });

        this.$vs.loading.close();
      });
    },
    createRequest() {
      let payload = {
        full_name: this.newRequest.full_name,
        phone: this.newRequest.phone,
        address: this.newRequest.address,
        services: this.newRequest.services,
        date_recommend: DateTime.fromFormat(
          this.newRequest.date_recommend,
          "dd.MM.yyyy HH:mm"
        ).toISO({ includeOffset: false, suppressMilliseconds: true }),
        user: this.newRequest.user,
      };

      try {
        this.$load(async () => {
          let res = await this.$api.services.createRequest(payload);

          this.notification("Успешно", "Заявка создана", "success");

          this.$router.push({ name: "requests" });
        });
      } catch (err) {
        this.notification("Ошибка", "Не удалось создать заявку", "danger");
      }
    },
  },
  created() {},
  mounted() {
    this.getAllusers();
    this.getAllCategory();
  },
};
</script>